import React from 'react';
import styled from 'styled-components';
import { IconArrowRight, cssColorValue } from '@spotify-internal/encore-web';
import { ButtonTertiaryLink, ContentfulImage, DELAYS, fadeInAnimation, withAnimationContext, ImageAspectBox9x16, SectionHeader, VideoPlayer, } from '../../ui';
import { fixHref } from '../../ui/utils';
const SegmentTextLink = withAnimationContext(styled(ButtonTertiaryLink) `
    ${fadeInAnimation(DELAYS.FIFTH)};
    color: ${cssColorValue('textBase')};
    &&:hover:not(:disabled),
    &:focus:not(:disabled),
    &:active:not(:disabled) {
      transform: none;
      color: ${cssColorValue('textBase')} !important;
      opacity: 0.5 !important;
    }

    svg {
      [dir='rtl'] & {
        transform: scaleX(-1);
      }
    }
  `);
const TRACK_CAT = 'module-featuredContent2Up';
export const TwoUpSegmentText = ({ segmentHeadline, segmentBody, segmentLinkText, segmentLinkUrl, segmentLinkOpenNewTab = false, }) => {
    return (React.createElement(SectionHeader, { subhead: segmentHeadline, body: segmentBody, cta: segmentLinkText && (React.createElement(SegmentTextLink, { href: fixHref(segmentLinkUrl), track: [TRACK_CAT, `Link - ${segmentLinkText}`], iconTrailing: () => React.createElement(IconArrowRight, { iconSize: 16 }), condensed: true, target: segmentLinkOpenNewTab ? '_blank' : '_self', label: segmentLinkText })), ctaVariation: "tertiary" }));
};
const ImageWrapper = styled(ImageAspectBox9x16) ``;
export const TwoUpSegmentMedia = ({ segmentImage, segmentVideo, className, forcePlayOnHover, }) => {
    const videoProps = forcePlayOnHover
        ? Object.assign(Object.assign({}, segmentVideo), { playButtonOnLoad: false, playOnHover: true }) : segmentVideo;
    return (React.createElement(React.Fragment, null,
        segmentImage && !segmentVideo && (React.createElement(ImageWrapper, { className: className },
            React.createElement(ContentfulImage, { asset: segmentImage }))),
        !segmentImage && segmentVideo && (React.createElement("div", { className: className },
            React.createElement(VideoPlayer, Object.assign({}, videoProps))))));
};
//# sourceMappingURL=TwoUpSegment.js.map